import { IInventoryIn } from "../../models/input/agendaApi/IInventoryIn";
import * as ApiWithToken from "../callApiWithToken";


const inventoryService = {
    getInventory:async function(posCode:string){
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `Inventory/getInventory?posCode=${posCode}`);
    },
    insertInventory:async function(inventoryInsertIn:IInventoryIn[]){
        return ApiWithToken.postApi(process.env.REACT_APP_AGENDAS_API + `Inventory/InsertInventory`, inventoryInsertIn);
    },
    getProducts:async function(posCode:string, brandId:number){
        return ApiWithToken.getApi(process.env.REACT_APP_MASTER_DATA_API + `Products/GetProductsByBrand?posCode=${posCode}&brandId=${brandId}`);
    }
    
}
export default inventoryService;
